import { EPOCHS_MILLIS, EPOCHS_SECS, MERGE_PARAM } from 'constants/castTypes';
import * as c from 'utils/fieldConstants';

const LOYAL = 'loyal';
const POSITIVE = 'positive';
const NEUTRAL = 'neutral';
const NEGATIVE = 'negative';
const UNSCORED = 'unscored';

export const BRAND_AFFINITY_OPTIONS = [
  { key: LOYAL, text: LOYAL, value: LOYAL },
  { key: POSITIVE, text: POSITIVE, value: POSITIVE },
  { key: NEUTRAL, text: NEUTRAL, value: NEUTRAL },
  { key: NEGATIVE, text: NEGATIVE, value: NEGATIVE },
  { key: UNSCORED, text: UNSCORED, value: UNSCORED },
];

export const CAST_SELECT_OPTIONS = [
  { key: EPOCHS_MILLIS, text: EPOCHS_MILLIS, value: EPOCHS_MILLIS },
  { key: EPOCHS_SECS, text: EPOCHS_SECS, value: EPOCHS_SECS },
  { key: MERGE_PARAM, text: MERGE_PARAM, value: MERGE_PARAM },
];

export const SINGLE_SELECT_FIELDS = [
  c.CAMPAIGN_LABEL,
  c.LIST_MEMBERSHIP_SINGLE,
  c.LIST_MEMBERSHIP,
  c.USER_LIST_MEMBERSHIP,
  c.USER_LIST_MEMBERSHIP_SINGLE,
  c.SUBSCRIBED_MESSAGE_TYPES,
  c.UNSUBSCRIBED_CHANNELS,
  c.UNSUBSCRIBED_MESSAGE_TYPES,
  c.MESSAGE_CHANNEL,
  c.MESSAGE_TYPE,
  c.BRAND_AFFINITY,
];

export const MULTI_SELECT_FIELDS = [c.CAMPAIGN, c.RECURRING_CAMPAIGN, c.EXIT_RULE_ID, c.WORKFLOW];

export const SELECT_FIELDS = [...SINGLE_SELECT_FIELDS, ...MULTI_SELECT_FIELDS];

export const MAX_JOURNEY_FIELD_LENGTH = 16000;

export const EXIT_RULE_ID_PLACEHOLDER = '💡 Tip: Copy/paste from your journey';
